(function() {
    'use strict';

    FileDownloadController.$inject = [
        '$window',
        'fileDownloadService',
        'v4FileDownloadService',
        'firmService'
    ];
    
    function FileDownloadController($window, fileDownloadService, v4FileDownloadService, firmService) {
        var vm = this;

        vm.downloadFile = downloadFile;

        function downloadFile(firmId, fileId) {

            return firmService.getFirmVersion()
                .then(
                    function (version) {
                        if (version === 4) {
                            return v4FileDownloadService.downloadFile(fileId);
                        } else {
                            return fileDownloadService.download(firmId, fileId);
                        }
                    },
                    function (message) {
                        $window.console.error(message);
                    });
        }
    }

    module.exports = FileDownloadController;
})();